(function(){
  var ROOT = '[data-bk-cloud-v6]';
  var KEY = 'bkCloudPortalV6State';
  var QUESTS = [
    { id:'gate', title:'Wake The Gate', skill:'Self-Awareness', copy:'Choose one intention before you enter the Floating Cloud Kingdom.', caption:'The Cloud Gate is listening.', choices:['I choose curiosity','I choose kindness','I choose courage','I choose calm'], reward:{ coins:5, sticker:'Phoenix Spark Sticker' } },
    { id:'cloud', title:'Ask The Cloud', skill:'Curiosity', copy:'Hear the cloud wonder, then answer with imagination.', caption:'How does the light ripple like that?', choices:['I feel curious','I feel amazed','I want to follow the light','I want to ask another question'], reward:{ coins:5, sticker:'Curiosity Spark Sticker' } },
    { id:'ripple', title:'Catch A Ripple', skill:'Kindness', copy:'Send one kind ripple into the Cloud Kingdom.', caption:'I have never seen anything like it.', choices:['Say something kind','Help someone','Share your art','Take a calming breath'], reward:{ coins:5, sticker:'Kindness Ripple Sticker' } },
    { id:'breath', title:'Gentle Breath Glow', skill:'Calm', copy:'Breathe in as the cloud grows. Breathe out as the light softens.', caption:'Breathe in. Breathe out. Let the light soften.', choices:['One gentle breath','Two gentle breaths','I can pause','I can begin again'], reward:{ coins:10, badge:'Cloud Explorer Badge' } },
    { id:'chime', title:'Kindness Chime', skill:'Prosocial Choice', copy:'Choose one kind action that can brighten the room.', caption:'A kind sound can open a brighter door.', choices:['Use kind words','Invite someone in','Listen first','Say thank you'], reward:{ coins:10, sticker:'Kindness Chime Sticker' } },
    { id:'scent', title:'Scent Imagination', skill:'Sensory Imagination', copy:'Choose a Cloud Aura made from imaginary scent notes.', caption:'Pearl mist. Rain glass. Vanilla cloud. Fresh sky air.', choices:['Pearl Mist','Rain Glass','Vanilla Cloud','Crystal Bloom'], reward:{ coins:10, badge:'Cloud Aura Badge', stamp:'Cloud Sensor Stamp' } }
  ];
  var FRAMES = [
    { id:'celestial', name:'Celestial Crown', inset:'24%', url:'https://cdn.shopify.com/s/files/1/0500/7307/5871/files/01-celestial-crown-ultra-bling-frame-transparent_1.png?v=1781114715' },
    { id:'royal', name:'Royal Diamond Palace', inset:'21%', url:'https://cdn.shopify.com/s/files/1/0500/7307/5871/files/02-royal-diamond-palace-ultra-bling-frame-transparent_1.png?v=1781114714' },
    { id:'amethyst', name:'Cosmic Amethyst Royal', inset:'22.5%', url:'https://cdn.shopify.com/s/files/1/0500/7307/5871/files/06-cosmic-amethyst-royal-ultra-bling-frame-transparent__1.png?v=1781114715' },
    { id:'lotus', name:'Lotus Mandala Jewel', inset:'21.5%', url:'https://cdn.shopify.com/s/files/1/0500/7307/5871/files/07-lotus-mandala-jewel-ultra-bling-frame-transparent_1.png?v=1781114715' },
    { id:'rose', name:'Rose Gold Couture Diamond', inset:'22%', url:'https://cdn.shopify.com/s/files/1/0500/7307/5871/files/08-rose-gold-couture-diamond-ultra-bling-frame-transparent_1.png?v=1781114715' },
    { id:'hologold', name:'Futuristic Hologold Diamond', inset:'24.5%', url:'https://cdn.shopify.com/s/files/1/0500/7307/5871/files/10-futuristic-hologold-diamond-ultra-bling-frame-transparent_1.png?v=1781114715' }
  ];
  var EMPTY_HUBS = [
    ['/pages/bacci-kid-heartopedia-toddler-hub','Toddler Hub'],
    ['/pages/bacci-kid-heartopedia-kid-hub','Kids Hub'],
    ['/pages/bacci-kid-heartopedia-tween-hub','Tweens Hub'],
    ['/pages/bacci-kid-heartopedia-teen-hub','Brave Teen Hub'],
    ['/pages/bacci-kid-heartopedia-adult-hub','Grown-Ups Hub'],
    ['/pages/bacci-kid-heartopedia-senior-hub','Seniors Hub']
  ];
  function $(root, sel){ return root.querySelector(sel); }
  function $all(root, sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function parse(raw, fallback){ try { return raw ? JSON.parse(raw) : fallback; } catch(e){ return fallback; } }
  function read(){
    var s = parse(localStorage.getItem(KEY), {});
    s.completed = Array.isArray(s.completed) ? s.completed : [];
    s.artSlots = s.artSlots && typeof s.artSlots === 'object' ? s.artSlots : {};
    s.mode = s.mode || 'cinematic';
    s.sound = !!s.sound;
    s.captions = s.captions !== false;
    return s;
  }
  function save(s){ localStorage.setItem(KEY, JSON.stringify(s)); return s; }
  function has(s,id){ return s.completed.indexOf(id) >= 0; }
  function quest(id){ return QUESTS.filter(function(q){ return q.id === id; })[0]; }
  function completedCount(s){ return QUESTS.filter(function(q){ return has(s,q.id); }).length; }
  function unlocks(s,id){
    var count = completedCount(s);
    if(id === 'gate') return true;
    if(id === 'cloud' || id === 'ripple') return has(s,'gate');
    if(id === 'breath') return count >= 2;
    if(id === 'chime' || id === 'scent') return count >= 3;
    if(id === 'art') return count >= 4 || Object.keys(s.artSlots).length > 0;
    if(id === 'door') return count >= 4 || Object.keys(s.artSlots).length > 0;
    return false;
  }
  function toast(root, msg){
    var t = $(root,'[data-toast]'); if(!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._timer); t._timer=setTimeout(function(){ t.classList.remove('is-on'); }, 3200);
  }
  function confetti(){
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    for(var i=0;i<64;i++){
      var p=document.createElement('i'); p.className='bkcp6-confetti';
      p.style.left=Math.random()*100+'vw';
      p.style.background=['#ffd76a','#58f4ea','#ff6fbf','#b9ffe9','#756bff'][i%5];
      p.style.animationDelay=(Math.random()*.45)+'s';
      p.style.transform='rotate('+(Math.random()*240)+'deg)';
      document.body.appendChild(p);
      setTimeout((function(el){ return function(){ el.remove(); }; })(p), 2200);
    }
  }
  function rewards(){ return window.BKCloudRewardsV1 ? window.BKCloudRewardsV1.read() : { coins:0, stickers:[], badges:[], stamps:[] }; }
  function award(r){ return window.BKCloudRewardsV1 ? window.BKCloudRewardsV1.award(r) : rewards(); }
  function readArt(){
    if(window.BKArtVaultV2) return window.BKArtVaultV2.read();
    if(window.BKArtVault && window.BKArtVault.read) return window.BKArtVault.read();
    return [];
  }
  function render(root){
    var s = read();
    root.setAttribute('data-mode', s.mode || 'cinematic');
    $all(root,'[data-set-mode]').forEach(function(b){ b.setAttribute('aria-pressed', b.getAttribute('data-set-mode') === s.mode ? 'true':'false'); });
    var video = $(root,'.bkcp6-quest-video');
    var heroVideo = $(root,'.bkcp6-hero-video');
    if(video){ video.muted = !s.sound; if(s.mode !== 'calm'){ video.play().catch(function(){}); } }
    if(heroVideo){ heroVideo.muted = true; if(s.mode !== 'calm'){ heroVideo.play().catch(function(){}); } }
    var count = completedCount(s);
    var pct = Math.min(100, Math.round((count/6)*100));
    var pb = $(root,'[data-progress-bar]'); if(pb) pb.style.setProperty('--p', pct + '%');
    var pt = $(root,'[data-progress-text]'); if(pt) pt.textContent = count + ' / 6 discoveries';
    var mt = $(root,'[data-mission-title]');
    var mc = $(root,'[data-mission-copy]');
    if(mt && mc){
      if(!has(s,'gate')){ mt.textContent='Start Here: Wake the Living Gate'; mc.textContent='Choose your intention. The first light wakes the Cloud Gate.'; }
      else if(count < 2){ mt.textContent='Follow the First Cloud Clues'; mc.textContent='Try Ask The Cloud or Catch Ripple. Each discovery wakes more of the portal.'; }
      else if(count < 4){ mt.textContent='Collect Four Discoveries'; mc.textContent='Breathe, chime, imagine, and follow the light to unlock the passport stamp.'; }
      else { mt.textContent='Passport Stamp Ready'; mc.textContent='Open your Wonderverse Passport, hang your art, and reveal the Hidden Sky Door.'; }
    }
    $all(root,'[data-hotspot]').forEach(function(btn){
      var id = btn.getAttribute('data-hotspot');
      var qid = id === 'door' || id === 'art' ? id : id;
      var can = unlocks(s, qid);
      btn.hidden = !can;
      btn.disabled = !can;
      btn.classList.toggle('is-locked', !can);
      btn.classList.toggle('is-done', has(s, id));
      if(id === 'art') btn.classList.toggle('is-done', Object.keys(s.artSlots).length > 0);
    });
    $all(root,'[data-quest]').forEach(function(btn){
      var id=btn.getAttribute('data-quest'); var can=unlocks(s,id);
      btn.hidden = !can;      btn.disabled = !can;
      btn.classList.toggle('is-done', has(s,id));
    });
    var cap=$(root,'[data-caption]');
    if(cap) cap.textContent = s.captions ? (count >= 2 ? 'I have never seen anything like it.' : 'How does the light ripple like that?') : '';
    var rw = rewards();
    setText(root,'[data-coins]', rw.coins);
    setText(root,'[data-stickers]', rw.stickers.length);
    setText(root,'[data-badges]', rw.badges.length);
    setText(root,'[data-coins-card]', rw.coins);
    setText(root,'[data-stickers-card]', rw.stickers.length);
    setText(root,'[data-badges-card]', rw.badges.length);
    setText(root,'[data-level]', rw.stamps.length >= 1 ? '2 Cloud Explorer' : '1 Dreamer');
    setText(root,'[data-next-reward]', nextReward(s, rw));
    $all(root,'[data-stamp]').forEach(function(st){ st.classList.toggle('is-earned', rw.stamps.indexOf(st.getAttribute('data-stamp')) >= 0 || (st.getAttribute('data-stamp')==='cloud' && count>=4)); });
    renderWall(root, s);
  }
  function setText(root, sel, txt){ var el=$(root,sel); if(el) el.textContent=txt; }
  function nextReward(s, rw){
    var count=completedCount(s);
    if(count < 1) return 'Curiosity Spark Sticker';
    if(count < 2) return 'Kindness Ripple Sticker';
    if(count < 3) return 'Cloud Explorer Badge';
    if(count < 4) return 'Cloud Sensor Passport Stamp';
    if(Object.keys(s.artSlots).length < 1) return 'Cloud Curator Badge';
    return 'Hidden Sky Door Reveal';
  }
  function completeQuest(root, id){
    var q=quest(id); if(!q) return;
    var s=read();
    if(s.completed.indexOf(id) < 0){
      s.completed.push(id);
      save(s);
      var reward = q.reward || {};
      if(completedCount(s) >= 4 && !s.stampAwarded){ reward = Object.assign({}, reward, { stamp:'cloud', badge:'Cloud Sensor Badge', coins:(reward.coins||0)+15 }); s.stampAwarded=true; save(s); }
      award(reward);
      confetti();
      toast(root, q.title + ' complete. Reward unlocked.');
    }
    closeQuest(root);
    render(root);
    if(completedCount(read()) >= 4){ openPanel(root,'reward'); }
  }
  function openQuest(root, id){
    if(id === 'art'){ openVault(root); return; }
    if(id === 'door'){ openPanel(root,'door'); return; }
    var s=read(); if(!unlocks(s,id)){ toast(root,'This discovery unlocks soon.'); return; }
    var q=quest(id); if(!q) return;
    var modal=$(root,'[data-quest-modal]'); if(!modal) return;
    modal.hidden=false;
    modal._questId=id;
    setText(root,'[data-quest-title]', q.title);
    setText(root,'[data-quest-skill]', q.skill);
    setText(root,'[data-quest-copy]', q.copy);
    var box=$(root,'[data-quest-choices]');
    if(box){
      box.innerHTML='';
      q.choices.forEach(function(choice, idx){
        var b=document.createElement('button'); b.type='button'; b.textContent=choice; if(idx===0) b.classList.add('is-selected');
        b.addEventListener('click', function(){ $all(box,'button').forEach(function(x){x.classList.remove('is-selected')}); b.classList.add('is-selected'); });
        box.appendChild(b);
      });
    }
  }
  function closeQuest(root){ var m=$(root,'[data-quest-modal]'); if(m) m.hidden=true; }
  function openPanel(root, type){
    var panel=$(root,'[data-panel]'); var box=$(root,'[data-panel-content]'); if(!panel || !box) return;
    var html='';
    if(type === 'guide') html = '<p class="bkcp6-kicker">Cloud Guide</p><h2>Welcome, Cloud Explorer</h2><p>I will help you wake the gate, collect discoveries, open your passport, and bring your Heartopedia art into the Museum.</p><div class="bkcp6-choice-row"><button data-scroll-target="#'+root.id+' .bkcp6-hubs">Choose Hub</button><button data-scroll-target="#'+root.id+' .bkcp6-quest">Start Quest</button><button data-open-vault>Open Art Vault</button><button data-scroll-target="#'+root.id+' .bkcp6-gates">View Gates</button></div>';
    if(type === 'spark') html = '<p class="bkcp6-kicker">Today’s Spark</p><h2>Choose One Tiny Bright Thing</h2><p>Your Daily Spark is a gentle invitation, not a streak or pressure.</p><div class="bkcp6-choice-row"><button>Send one kind ripple</button><button>Name one feeling</button><button>Choose one brave thought</button><button>Notice one beautiful detail</button></div>';
    if(type === 'passport' || type === 'reward') html = '<p class="bkcp6-kicker">Passport Ceremony</p><h2>Passport Stamp Earned</h2><p>You woke the Cloud Gate, followed the light, and shared kindness. Your Cloud Sensor Stamp has been added to your Wonderverse Passport.</p><div class="bkcp6-choice-row"><button data-open-vault>Hang My Art</button><button data-scroll-target="#'+root.id+' .bkcp6-gates">Preview Next Gate</button></div><p><strong>Stickers, badges, and Bacci Kid Gold Coins are earned just for fun. They have no cash value and cannot be redeemed for money or merchandise.</strong></p>';
    if(type === 'door') html = '<p class="bkcp6-kicker">Hidden Sky Door</p><h2>The Next Gate Is Listening</h2><p>Complete discoveries and hang Heartopedia art to make more Wonderverse worlds glow.</p><div class="bkcp6-choice-row"><a class="bkcp6-btn" href="/pages/bacci-kid-museum-portals">Return to Wonderverse</a><a class="bkcp6-btn" href="/pages/coming-soon-cinematic">Watch Bacci Kid TV</a></div>';
    box.innerHTML=html;
    panel.hidden=false;
  }
  function closePanel(root){ var p=$(root,'[data-panel]'); if(p) p.hidden=true; }
  function openVault(root){
    var modal=$(root,'[data-vault-modal]'); if(!modal) return;
    modal.hidden=false;
    renderVault(root);
  }
  function closeVault(root){ var m=$(root,'[data-vault-modal]'); if(m) m.hidden=true; }
  function renderVault(root){
    var art=readArt();
    var list=$(root,'[data-vault-list]');
    if(list){
      list.innerHTML='';
      if(!art.length){
        var empty=document.createElement('div'); empty.className='bkcp6-empty-vault';
        empty.innerHTML='<b>No Heartopedia artwork found on this device yet.</b><p>Create or finish Heartopedia artwork first, then return here to hang it in the Museum.</p>'+EMPTY_HUBS.map(function(h){return '<a href="'+h[0]+'">'+h[1]+'</a>';}).join('');
        list.appendChild(empty);
      } else {
        art.forEach(function(item, idx){
          var b=document.createElement('button'); b.type='button'; b.setAttribute('data-art-choice', item.id); if(idx===0){ b.classList.add('is-selected'); root._bkcp6Art=item; }
          b.innerHTML='<img src="'+escapeAttr(item.image)+'" alt=""><span><b>'+escapeHtml(item.title)+'</b><small>'+escapeHtml(item.hub || 'Heartopedia')+'</small></span>';
          b.addEventListener('click', function(){ $all(list,'button').forEach(function(x){x.classList.remove('is-selected')}); b.classList.add('is-selected'); root._bkcp6Art=item; });
          list.appendChild(b);
        });
      }
    }
    var frameList=$(root,'[data-frame-list]');
    if(frameList){
      frameList.innerHTML='';
      FRAMES.forEach(function(frame, idx){
        var b=document.createElement('button'); b.type='button'; if(idx===0){ b.classList.add('is-selected'); root._bkcp6Frame=frame; }
        b.innerHTML='<img src="'+frame.url+'" alt=""><span><b>'+frame.name+'</b><small>Jewel frame</small></span>';
        b.addEventListener('click', function(){ $all(frameList,'button').forEach(function(x){x.classList.remove('is-selected')}); b.classList.add('is-selected'); root._bkcp6Frame=frame; });
        frameList.appendChild(b);
      });
    }    var slots=$all(root,'[data-slot-choice]');
    slots.forEach(function(b, idx){ b.classList.toggle('is-selected', idx===0); if(idx===0) root._bkcp6Slot='1'; b.addEventListener('click', function(){ slots.forEach(function(x){x.classList.remove('is-selected')}); b.classList.add('is-selected'); root._bkcp6Slot=b.getAttribute('data-slot-choice'); }); });
  }
  function placeArt(root){
    var item=root._bkcp6Art, frame=root._bkcp6Frame || FRAMES[0], slot=root._bkcp6Slot || '1';
    if(!item){ toast(root,'Create Heartopedia art first, then return to hang it.'); return; }
    var name=($(root,'[data-nameplate]') || {}).value || item.title || 'Heartopedia Art';
    var s=read();
    s.artSlots[slot] = { image:item.image, title:item.title, hub:item.hub, frame:frame.url, nameplate:name, at:Date.now() };
    if(!s.artAwarded){ s.artAwarded=true; award({ coins:25, badge:'Cloud Curator Badge', sticker:'Cloud Curator Sticker', stamp:'curator' }); confetti(); }
    save(s);
    closeVault(root);
    render(root);
    toast(root,'Your artwork is now in the Museum. Cloud Curator Badge unlocked.');
  }
  function renderWall(root, s){
    $all(root,'[data-wall-slot]').forEach(function(slot){
      var n=slot.getAttribute('data-wall-slot'); var data=s.artSlots[n];
      if(!data){ slot.innerHTML='<span>＋</span><small>Frame Slot '+n+'</small>'; return; }
      slot.innerHTML='<img class="bkcp6-placed-art" src="'+escapeAttr(data.image)+'" alt="'+escapeAttr(data.nameplate || 'Heartopedia art')+'"><img class="bkcp6-frame-overlay" src="'+escapeAttr(data.frame || FRAMES[0].url)+'" alt=""><strong class="bkcp6-nameplate">'+escapeHtml(data.nameplate || 'Heartopedia Art')+'</strong>';
    });
  }
  function escapeHtml(s){ return String(s).replace(/[&<>'"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]; }); }
  function escapeAttr(s){ return escapeHtml(s); }
  function setupTilt(root){
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    $all(root,'[data-bkcp6-tilt]').forEach(function(el){
      el.addEventListener('pointermove', function(e){
        if(root.getAttribute('data-mode') === 'calm') return;
        var b=el.getBoundingClientRect(), x=(e.clientX-b.left)/b.width, y=(e.clientY-b.top)/b.height;
        el.style.setProperty('--tiltY', ((x-.5)*5).toFixed(2)+'deg');
        el.style.setProperty('--tiltX', ((.5-y)*5).toFixed(2)+'deg');
        el.style.setProperty('--mx', (x*100).toFixed(1)+'%');
        el.style.setProperty('--my', (y*100).toFixed(1)+'%');
      }, { passive:true });
      el.addEventListener('pointerleave', function(){ el.style.setProperty('--tiltY','0deg'); el.style.setProperty('--tiltX','0deg'); });
    });
  }
  function setupSpark(root){
    var last=0;
    root.addEventListener('pointermove', function(e){
      if(root.getAttribute('data-mode') !== 'cinematic') return;
      if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var now=Date.now(); if(now-last<90) return; last=now;
      var s=document.createElement('span'); s.className='bkcp6-spark'; s.style.left=e.clientX+'px'; s.style.top=e.clientY+'px'; document.body.appendChild(s);
      setTimeout(function(){ s.remove(); }, 820);
    }, { passive:true });
  }
  function initRoot(root){
    if(root._bkcp6Ready) return; root._bkcp6Ready=true;
    var s=read(); root.setAttribute('data-mode', s.mode || 'cinematic');
    setupTilt(root); setupSpark(root); render(root);
    root.addEventListener('click', function(e){
      var mode=e.target.closest('[data-set-mode]');
      if(mode){ var st=read(); st.mode=mode.getAttribute('data-set-mode'); save(st); render(root); return; }
      var sound=e.target.closest('[data-toggle-sound]');
      if(sound){ var ss=read(); ss.sound=!ss.sound; sound.textContent=ss.sound?'Sound On':'Sound Off'; sound.setAttribute('aria-pressed', ss.sound?'true':'false'); save(ss); render(root); return; }
      var cc=e.target.closest('[data-toggle-captions]');
      if(cc){ var sc=read(); sc.captions=!sc.captions; cc.textContent=sc.captions?'CC On':'CC Off'; cc.setAttribute('aria-pressed', sc.captions?'true':'false'); save(sc); render(root); return; }
      var lang=e.target.closest('[data-toggle-lang]');
      if(lang){ toast(root,'Korean draft captions can be added in the next language pass.'); return; }
      var scroll=e.target.closest('[data-scroll-target]');
      if(scroll){ var target=document.querySelector(scroll.getAttribute('data-scroll-target')); if(target) target.scrollIntoView({behavior: read().mode==='calm'?'auto':'smooth', block:'start'}); closePanel(root); return; }
      var focus=e.target.closest('[data-focus-quest]');
      if(focus){ openQuest(root, focus.getAttribute('data-focus-quest')); return; }
      var hotspot=e.target.closest('[data-hotspot]');
      if(hotspot){ openQuest(root, hotspot.getAttribute('data-hotspot')); return; }
      var q=e.target.closest('[data-quest]');
      if(q){ openQuest(root, q.getAttribute('data-quest')); return; }
      if(e.target.closest('[data-open-vault]')){ openVault(root); return; }
      var panel=e.target.closest('[data-open-panel]');
      if(panel){ openPanel(root, panel.getAttribute('data-open-panel')); return; }
      if(e.target.closest('[data-close-panel]')){ closePanel(root); return; }
      if(e.target.closest('[data-close-quest]')){ closeQuest(root); return; }
      if(e.target.closest('[data-close-vault]')){ closeVault(root); return; }
      if(e.target.closest('[data-complete-quest]')){ var m=$(root,'[data-quest-modal]'); completeQuest(root, m && m._questId); return; }
      if(e.target.closest('[data-place-art]')){ placeArt(root); return; }
    });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ closePanel(root); closeQuest(root); closeVault(root); } });
    window.addEventListener('bk:rewards:update', function(){ render(root); });
    window.addEventListener('bk:artvault:update', function(){ renderVault(root); render(root); });
    var resetClicks=0, resetTimer;
    var logo=root.querySelector('.bkcp6-brand img');
    if(logo){ logo.addEventListener('click', function(e){ resetClicks++; clearTimeout(resetTimer); resetTimer=setTimeout(function(){resetClicks=0;},900); if(resetClicks>=7){ e.preventDefault(); resetClicks=0; localStorage.removeItem(KEY); if(window.BKCloudRewardsV1) window.BKCloudRewardsV1.reset(); alert('Cloud Portal v6 progress reset for testing.'); location.reload(); } }); }
  }
  function init(){ document.querySelectorAll(ROOT).forEach(initRoot); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true }); else init();
})();